import { createAction } from '@reduxjs/toolkit';
export const bulkUpdateTickets = createAction('realtime/BulkUpdateTickets', ({
  added,
  updated,
  removed,
  customViewId,
  sortState
}) => {
  return {
    payload: {
      added,
      updated,
      removed,
      customViewId,
      sortState
    }
  };
});